/**
 * Seamly Channel API
 * The API for Seamly Channel REST API <br/><br/> **Please note**: You can view which schemas apply to an endpoint by navigating to the response of an endpoint and then clicking on *Schema*, right next to *Example Value*. By default example values are shown for each response.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@seamly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Ping {
    type: Ping.TypeEnum;
}
export namespace Ping {
    export type TypeEnum = 'ping';
    export const TypeEnum = {
        Ping: 'ping' as TypeEnum
    };
}
